import axios from 'axios'

const clientId = process.env.VUE_APP_CLIENT_ID || "776c49ec-4837-493a-9d7b-010482c15d00";
const tenantId = "0f277086-d4e0-4971-bc1a-bbc5df0eb246";
const redirectUri = window.location.origin;
const scope = "User.Read Sites.Read.All Group.Read.All";
const state = Math.random().toString(36).substring(7);
const loginUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=token&redirect_uri=${encodeURIComponent(redirectUri)}&response_mode=fragment&scope=${encodeURIComponent(scope)}&state=${state}`
const sendDataUrl = 'https://prod-14.northeurope.logic.azure.com:443/workflows/455a7398bab64bc390c0465fe9552e9f/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=o11zBGc73in9lFxef6pssj__IdNJzJiZqEHSy4plGDc'
const queueName = 'kisso2'
const applicationName = 'Repatriace'

class ApiService {
  static gotoLogin() {
    if (!window.location.href.includes('access_token')) {
      window.location.href = loginUrl
    }
  }
  
  static getExcels(url) {
    const urlParams = new URLSearchParams(window.location.hash.substring(1))
    let token = urlParams.get('access_token')

    return axios.get(url,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        },
      })
  }

  static sendData(formData) {

    const urlParams = new URLSearchParams(window.location.hash.substring(1))
    const token = urlParams.get('access_token')
    const tokenPayload = token.split('.')[1]
    const decodedString = atob(tokenPayload)
    const info = JSON.parse(decodedString).unique_name

    let messageData = {
      "address": formData.phoneNumbers.map(num => String(num)),
      "message": formData.smsText,
      "queuename": queueName,
      "priority": 100,
      "applicationname": applicationName,
      "info": info
    }

    return axios.post(sendDataUrl, messageData,
      {
        headers: {
          'content-type': 'application/json',
        },
      })
  }
}

export default ApiService
